<template>
  <div>
    <v-container>
      <h1>
        Your Beacons
        <v-modal-help style="font-size: 17px">
          <div slot="body">
            <v-card-text>
              <h1 class="mb-2">LINE Beacon (บีคอน)</h1>
              <p style="color: black">
                เป็นเทคโนโลยีที่ใช้สำหรับการส่งข้อความในไลน์ผ่าน Bluetooth ได้ฟรี โดยไม่เสียค่า Push
                Message โดยเมื่อเราเดินเข้าไปในรัศมีที่มี LINE Beacon ส่งสัญญาณถึง ก็จะได้รับข้อความ
                รูปภาพ ที่ร้านค้าตั้งไว้ทันที
              </p>
            </v-card-text>
          </div>
        </v-modal-help>
      </h1>
      <div class="mb-3">
        <div class="text-xs-right">
          <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
            <v-icon>search</v-icon>
            &nbsp;
            {{ $t('advanced search') }}&nbsp;
            <em v-if="!showAdvancedSearch" class="fas fa-angle-down" />
            <em v-else class="fas fa-angle-up" />
          </v-btn>
        </div>
        <div
          v-if="showAdvancedSearch"
          class="mb-4 py-2"
          style="border: 1px solid #eee; border-radius: 10px; position: relative"
        >
          <v-layout wrap class="form-control">
            <v-flex xs4 px-2>
              <div class="caption">Beacon ID:</div>
              <input v-model="filter.beacon_id" type="text" placeholder="Beacon ID" />
            </v-flex>
            <v-flex xs4 px-2>
              <div class="caption">{{ $t('name') }}:</div>
              <input v-model="filter.beacon_name" type="text" :placeholder="$t('name')" />
            </v-flex>
            <v-flex xs4 px-2>
              <div class="caption">{{ $t('location') }}:</div>
              <input v-model="filter.beacon_location" type="text" :placeholder="$t('location')" />
            </v-flex>

            <v-flex xs12 class="text-xs-right">
              <v-btn outline color="grey" @click="handleClearSearch">{{
                $t('Clear Search')
              }}</v-btn>
              <v-btn depressed color="primary" @click="handleSearch">
                <em class="fas fa-search mr-1" />
                {{ $t('Search') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div>
        <div style="margin-bottom: 10px">
          <a
            v-if="!isShow"
            href="javascript:void(0);"
            @click="
              isShow = true
              beaconItem = {}
            "
          >
            <div class="add-conversation text-xs-center">
              <i class="fa fa-plus middle"></i>
              {{ $t('add_beacon_information') }}
            </div>
          </a>
          <div v-else class="intent-item z-border-red" style="padding: 10px 15px 0px">
            <BeaconManage
              type="add"
              @onSave="handleSaveBeacon($event, 'add')"
              @onCancel="isShow = false"
            />
          </div>
        </div>

        <div
          v-for="(item, index) in data"
          :key="index"
          class="intent-item z-border-red"
          style="padding: 10px 15px 10px"
        >
          <BeaconItem :item="item" @onFetchData="handleFetchData" />
        </div>
        <div class="text-xs-right mt-3">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pageLength"
            @input="handleChangePage"
          ></v-pagination>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import beaconApi from '@/api/beacon'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'
import BeaconManage from './BeaconManage'
import BeaconItem from './BeaconItem'

export default {
  components: {
    BeaconManage,
    BeaconItem
  },
  data() {
    return {
      isShow: false,
      data: [],
      showAdvancedSearch: false,
      filter: {
        beacon_id: '',
        beacon_name: '',
        beacon_location: ''
      },
      limit: 10,
      offset: 0,
      total: 0,
      pagetmp: 1,
      pageNumber: 1
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.handleFetchData()
  },
  methods: {
    handleFetchData() {
      this.getBeaconsList()
    },
    async getBeaconsList() {
      const vm = this
      try {
        const data = {
          limit: vm.limit,
          offset: vm.offset
        }

        for (const [key, value] of Object.entries(vm.filter)) {
          if (value) {
            Object.assign(data, { [key]: value })
          }
        }

        const response = await beaconApi.getBeaconsList({
          pageId: vm.selectedBot.pageid,
          config: data
        })
        handleResponse(response)
        if (response && response.status === 200) {
          vm.data = response.data.result.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          )
          vm.total = response.data.total
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async postCreateBeacon(beaconItem, type) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await beaconApi.postCreateBeacon({
          data: {
            pageid: vm.selectedBot.pageid,
            body: {
              beacon_id: beaconItem.beacon_id,
              name: beaconItem.name, // optional
              location: beaconItem.location, // optional
              tag: beaconItem.tags // optional
            }
          }
        })
        vm.$store.dispatch('loading')

        handleResponse(response)
        if (response && response.data && response.data.success) {
          if (type === 'add') {
            vm.isShow = false
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: `Beacon ${beaconItem.name} ${vm.$t('has_been_added')}`,
              type: 'success'
            })
          } else {
            vm.isEdit = false
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: `Beacon ${beaconItem.name} ${vm.$t('has_been_edited')}`,
              type: 'success'
            })
          }

          vm.getBeaconsList(1000, 0)
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
      }
    },

    handleSaveBeacon(value, type) {
      this.postCreateBeacon(value, type)
    },
    handleSearch() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleFetchData()
    },
    handleClearSearch() {
      this.filter = {
        beacon_id: '',
        name: '',
        location: ''
      }
      this.handleSearch()
      this.showAdvancedSearch = false
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleFetchData()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Beacon.vue